import { useEffect, useState } from 'react';
export var useDebounce = function (value, delay) {
    if (delay === void 0) { delay = 100; }
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timeout = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () { return clearTimeout(timeout); };
    }, [value]);
    return debouncedValue;
};
//# sourceMappingURL=hooks.js.map